import React from 'react';
import './../index.css';
import {
  Routes,
  Link,
  Route,
} from "react-router-dom";
import { About } from './About';
import { Bread } from './Bread';
import { EBSite } from './EBSite';
import './../fonts/Bakerie/BakerieSmooth-Black.otf';
import { GlutenFree } from './GlutenFree';
import { Contact } from './Contact';
import { Rolls } from './Rolls';
import { Cookies } from './Cookies';
import facebook_icon from './../images/facebook_icon.png';
import instagram_icon from './../images/instagram_icon.png';
import { Order } from './Order';
import { Title } from './Title';
import { Locations } from './Locations';
import { slide as Menu } from 'react-burger-menu';
import { BrowserRouter } from "react-router-dom";


export class NavBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };

    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenuState = this.toggleMenuState.bind(this);

  }


  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenuState(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  render() {
    return (
      <>
        {
          /*
          * Bread section
          */
        }
        <BrowserRouter>
          <Menu width={"calc(200px + 0.390625vw)"} onStateChange={(state) => this.toggleMenuState(state)} isOpen={this.state.menuOpen} left>
            <Link className='navLink' to="/" onClick={this.closeMenu}>Home</Link>
            <Link className='navLink' to="/bread" onClick={this.closeMenu}>Bread</Link>
            <Link className='navLink' to="/rolls" onClick={this.closeMenu}>Rolls</Link>
            <Link className='navLink' to="/cookies" onClick={this.closeMenu}>Cookies</Link>
            <Link className='navLink' to="/glutenfree" onClick={this.closeMenu}>Gluten Free</Link>
            <Link className='navLink' to="/locations" onClick={this.closeMenu}>Locations</Link>
            <Link className='navLink' to="/order" onClick={this.closeMenu}>Order</Link>
            <Link className='navLink' to="/contact" onClick={this.closeMenu}>Contact</Link>
          </Menu>
          <Title />

          <Routes>
            <Route path="/" element={<EBSite
              settings={this.props.settings}
            />} />
            <Route path="/about" element={<About />} />
            <Route path="/bread" element={<Bread
              settings={this.props.settings}
              docMap={this.props.docMap}
              recipeMap={this.props.recipeMap}
              ingredientMap={this.props.ingredientMap}
            />} />
            <Route path="/rolls" element={<Rolls
              settings={this.props.settings}
              docMap={this.props.docMap}
              recipeMap={this.props.recipeMap}
              ingredientMap={this.props.ingredientMap}
            />} />
            <Route path="/cookies" element={<Cookies
              settings={this.props.settings}
              docMap={this.props.docMap}
              recipeMap={this.props.recipeMap}
              ingredientMap={this.props.ingredientMap}
            />} />
            <Route path="/glutenfree" element={<GlutenFree
              settings={this.props.settings}
              docMap={this.props.docMap}
              recipeMap={this.props.recipeMap}
              ingredientMap={this.props.ingredientMap}
            />} />
            <Route path="/locations" element={<Locations
              settings={this.props.settings}
            />} />
            <Route path="/order" element={<Order
              settings={this.props.settings}
              docMap={this.props.docMap}
              recipeMap={this.props.recipeMap}
              ingredientMap={this.props.ingredientMap}
            />} />
            <Route path="/contact" element={<Contact
              settings={this.props.settings}
            />} />
          </Routes>
        </BrowserRouter>

      </>
    );
  }


}
